enum CustomerVerificationType {
  UPDATE_CUSTOMER_CONTACT_DETAIL = 1,
  KEY_HOLDER_INFORMATION = 2,
  DOMESTIC_WORKER = 3,
  SPECIAL_INSTRUCTIONS = 4,
  ACCESS_TO_PREMISES = 5,
  SITE_HAZARD = 6,
  CUSTOMER_VERIFICATION = 7,
  HOLIDAY_INSTRUCTION = 8,
  ARMING_AND_DISARMING_TIME = 9,
  DEBTOR_INFO = 10,
  QUICK_ADD_SERVICE_CALL_CREATION = 11,
  AA_PHONE_IN = 12,
  CREATE_PHONE_IN = 13,
  RISK_WATCH_SERVICE = 14,
  UPDATE_SITE_ADDRESS = 15,
  SERVICE_CALL = 16,
  DEALER_CALL = 17,
  CUSTOMER_PREFERENCE = 18,
}
enum CustomerVerificationRedirect {
  RISK_WATCH_SERVICE = "riskwatch"
}

export { CustomerVerificationType, CustomerVerificationRedirect }
